import { render, staticRenderFns } from "./StoneSection.vue?vue&type=template&id=527570d9&scoped=true&"
import script from "./StoneSection.vue?vue&type=script&lang=js&"
export * from "./StoneSection.vue?vue&type=script&lang=js&"
import style0 from "./StoneSection.vue?vue&type=style&index=0&id=527570d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527570d9",
  null
  
)

export default component.exports